<template>
  <div class="choice-city">
    <h2 class="choice-city__title">{{ messages.chooseCity }}</h2>

    <DefSelectSearch>
      <template #placeholder>
        {{ messages.placeholder }}
      </template>
      <template #header>
        {{ userCity.UF_NAME }}
      </template>
      <template #search>
        <input type="text" @input="handlerInput" />
      </template>
      <div v-for="city in cities" @click="setCity(city.UF_NAME)">
        {{ city.UF_NAME }}
      </div>
    </DefSelectSearch>

    <div class="choice-city__items">
      <span
        v-for="city in citiesMenu"
        :key="city.name"
        class="choice-city__item"
        :class="{ 'choice-city__item_active': city.active }"
        @click="setCity(city.name)"
        >{{ city.name }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefSelectSearch from '../Def/DefSelect/DefSelectSearch';

export default {
  name: 'ChoiceCity',
  components: {
    DefSelectSearch,
  },
  computed: {
    ...mapState({
      citiesMenu: ({ cities }) => cities.data.citiesMenu,
      messages: ({ cities }) => cities.data.messages,
      userCity: ({ cities }) => cities.data.userCity,
      routes: ({ cities }) => cities.data.routes,
      cities: ({ cities }) => cities.data.cities,
    }),
  },
  methods: {
    ...mapActions({
      setCity: 'cities/setCity',
      getCities: 'cities/getCities',
    }),
    handlerInput({ target: { value } }) {
      this.getCities(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.choice-city {
  //padding: 40px 16px;
  @include point-md {
    font-size: rem(16);
    //padding: 46px 32px;
  }
  &__title {
    margin-bottom: 24px;
    text-transform: uppercase;
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    cursor: pointer;
  }
  &__item {
    transition: 0.2s linear color;
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
    &:hover {
      color: var(--color-main);
    }
    &_active {
      color: var(--color-main);
      text-decoration: underline;
      text-underline-position: under;
    }
  }
  :deep(.def-select-search) {
    margin-bottom: 24px;
  }
  :deep(.def-select-search__scroll) {
    max-height: 159px;
  }
}
</style>
